/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneTextWithImageCompose({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const cta = _.get(data, 'cta', {});
  const singleImage = _.get(data, 'image', {});
  const multipleImages = _.get(data, 'orMultipleImages', []);

  const columnImages = [[], [], []];
  multipleImages.forEach((image, index) => {
    columnImages[index % 3].push(image);
  });

  return (
    <section id={id} className="relative overflow-hidden">
      <BoxedContainer>
        <div
          className="space-y-8 w-full lg:grid lg:grid-cols-12 py-12.5 md:py-16 
        lg:py-20 xl:py-30 gap-10 lg:gap-12.5">
          <div className="col-span-6 flex flex-col items-center lg:items-start gap-5">
            <div
              className="child:text-clamp20to40 child:ltr:!font-URWDINMedium 
              child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3] 
              last:child:!m-0 child:text-center lg:child:text-start child:text-[#231F20]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5" />
            <div
              className="child:text-clamp12to18 
              child:ltr:!font-URWDINRegular 
              child:rtl:!font-GESSTwoDWTCLight child:leading-1.4 
              last:child:!m-0 child:text-center col-span-6 lg:child:text-start child:text-[#4D4D4D]"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
          {!_.isEmpty(cta) && (
            <Link
              to={cta.url}
              className="w-fit flex justify-center items-center rounded-[48px] mx-auto lg:mx-0
              bg-[#CE445B] hover:bg-[#B53B50] text-white 
              uppercase 
              ltr:font-URWDINBold 
              rtl:font-GESSTwoDWTCMedium ltr:tracking-[0.96px] leading-1.5 md:leading-1.25
              min-h-[40px] md:h-[51px] text-center px-12 md:px-14 py-2
              rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
              rtl:lg:text-[18px]
              md:py-5 rtl:pt-[10px] ltr:pt-[11px] 
              ltr:md:pt-6 rtl:md:pt-5 col-span-4 lg:col-start-1 lg:col-span-3">
              {cta.name}
            </Link>
          )}
        </div>
      </BoxedContainer>

      {!_.isEmpty(multipleImages) && (
        <div
          className="lg:-mx-3 gallery w-full relative lg:absolute lg:inset-0 ltr:lg:!left-[unset]
          rtl:lg:!right-[unset]
        overflow-hidden max-h-full lg:max-w-44vw object-cover h-[400px] md:h-[600px] lg:h-full">
          <div className="flex h-full lg:w-auto w-[140%] -mx-[20%] lg:mx-0">
            <div className="w-1/3 image-wrapper">
              <div className="column animate-up">
                {columnImages[0].concat(columnImages[0])
                .concat(columnImages[0]).concat(columnImages[0])
                .map((image, index) => (
                  <div key={index} className="p-[7px] 2l:p-[12px]">
                    {image.url.includes('.mp4') ? (
                      <video
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        muted
                        playsInline
                        autoPlay
                        loop
                      />
                    ) : (
                      <img
                        width="100%"
                        height="100%"
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        alt={`Gallery ${index}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-1/3 image-wrapper">
              <div className="column animate-down">
                {columnImages[1].concat(columnImages[1])
                .concat(columnImages[1]).concat(columnImages[1])
                .map((image, index) => (
                  <div key={index} className="p-[7px] 2l:p-[12px]">
                    {image.url.includes('.mp4') ? (
                      <video
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        muted
                        playsInline
                        autoPlay
                        loop
                      />
                    ) : (
                      <img
                        width="100%"
                        height="100%"
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        alt={`Gallery ${index}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-1/3 image-wrapper">
              <div className="column animate-third">
                {columnImages[2].concat(columnImages[2])
                .concat(columnImages[2]).concat(columnImages[2])
                .map((image, index) => (
                  <div key={index} className="p-[7px] 2l:p-[12px]">
                    {image.url.includes('.mp4') ? (
                      <video
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        muted
                        playsInline
                        autoPlay
                        loop
                      />
                    ) : (
                      <img
                        width="100%"
                        height="100%"
                        className="w-full h-auto bg-slate-500"
                        src={image.url}
                        alt={`Gallery ${index}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {(multipleImages === null && _.isEmpty(singleImage)) && (
        <LazyLoadImage
          src={singleImage.url}
          alt="image composition"
          className="w-full h-auto relative lg:absolute lg:inset-0 lg:!left-[unset] max-h-80 
          lg:max-h-full lg:max-w-44vw object-cover lg:h-full"
        />
      )}
    </section>
  );
}

export default FreeZoneTextWithImageCompose;
